import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { HeaderPageRoutingModule } from './header-routing.module';

import { HeaderPage } from './header.page';
import { MenuPage } from '../menu/menu.page';
import { TranslateModule } from '@ngx-translate/core';
import { LoginPageModule } from '../login/login.module';
import { ModalPageModule } from '../modal/modal.module';
import { LogoutDialogPageModule } from '../shared/logout-dialog/logout-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderPageRoutingModule,
    TranslateModule,
    ModalPageModule,
    LoginPageModule,
    LogoutDialogPageModule,
  ],
  declarations: [HeaderPage],
  exports: [HeaderPage],
  providers: [MenuPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderPageModule {}
